export class GeneralHelpers {
    static ensureUnique(sectionName: string): string {
        let staticSections = [];
        for (let nextName of staticSections) {
            if (nextName === sectionName) {
                // If there's already a section by this name, add a "-" and the current Unix timestamp
                sectionName = sectionName + (new Date().getTime());
                break;
            }
        }

        return sectionName;
    }

    static slugify(text) {
        return text.toString().toLowerCase()
            .replace(/\s+/g, '-')           // Replace spaces with -
            .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
            .replace(/\-\-+/g, '-')         // Replace multiple - with single -
            .replace(/^-+/, '')             // Trim - from start of text
            .replace(/-+$/, '');            // Trim - from end of text
    }

    static getClosest(elem, selector) {
        // Get the closest matching element
        for ( ; elem && elem !== document; elem = elem.parentNode ) {
            if ( elem.matches( selector ) ) return elem;
        }
        return null;
    };

    static indexInParent(node) {
        let children = node.parentNode.childNodes;
        let num = 0;
        for (let i=0; i<children.length; i++) {
            if (children[i]==node) return num;
            if (children[i].nodeType==1) num++;
        }
        return -1;
    }
}


// WEBPACK FOOTER //
// ./src/ts/Apps/Common/helpers/general.helper.ts